import CardAnimation from 'components/CardAnimation'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { getProjectList } from 'apis/project.ts'
import ContactFloatingButton from 'components/ContactFloatingButton'

// const portfolioList = [
//   {
//     key: 'skyon',
//     portfolio: 'SKYON',
//     description: '유지보수 및 리뉴얼 개발',
//     organ: '(주)구마일에듀 (자회사)',
//     img: require('assets/images/portfolio-skyon.png'),
//     imgHeight: 1200,
//   },
// ]

export default function Portfolio() {
  const navigate = useNavigate()
  const onClickPortfolioDetail = (key) => {
    navigate(`/portfolio/detail/${key}`)
  }

  const [projectLeftList, setProjectLeftList] = useState([])
  const [projectRightList, setProjectRightList] = useState([])

  const getProjectListApi = async () => {
    let getProjectListResponse = await getProjectList()

    if (getProjectListResponse.error) {
      console.log(getProjectListResponse.message)
      return
    }
    if (!getProjectListResponse.data.projects) return
    const projectList = getProjectListResponse.data.projects
    let leftTotalHeight = 0
    let rightTotalHeight = 0
    const leftList = []
    const rightList = []

    projectList.forEach((portfolio) => {
      if (leftTotalHeight <= rightTotalHeight) {
        leftList.push(portfolio)
        leftTotalHeight += portfolio.imgHeight < 660 ? portfolio.imgHeight : 660
      } else {
        rightList.push(portfolio)
        rightTotalHeight += portfolio.imgHeight < 660 ? portfolio.imgHeight : 660
      }
    })

    setProjectLeftList(leftList)
    setProjectRightList(rightList)
  }

  useEffect(() => {
    getProjectListApi()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='wrapper'>
      <div className='container max-w-[1024px] mx-auto mb-[-220px] sm:mb-[-260px]'>
        <div className='px-20 py-64'>
          <div className='flex flex-col items-center w-full gap-4 mb-32'>
            <p className='text-title3-medium sm:text-title2-medium text-sk-black'>
              최적의 SW 파트너
            </p>
            <p className='text-title2-bold sm:text-title1-bold text-sk-bold'>
              시그마테크놀로지와 함께
            </p>
          </div>
          {/* 포트폴리오 렌더링 */}
          {/* normal flow 로직 */}
          <div className='flex divide-x-2'>
            {/* left */}
            <div className='w-1/2'>
              {projectLeftList.map((portfolio, index) => (
                <div
                  key={index}
                  className='mr-20 cursor-pointer lg:mr-32 2xl:mr-64'
                  onClick={() => onClickPortfolioDetail(portfolio.id)}
                >
                  {/* 포트폴리오 이미지 */}
                  <div className='mb-28'>
                    <CardAnimation card={portfolio} />
                  </div>
                  {/* 포트폴리오 설명 */}
                  <div className='flex flex-col-reverse md:flex-col gap-4 mb-[60px] sm:mb-80'>
                    <p className='text-body2-medium text-sk-info'>{portfolio.description}</p>
                    <div className='flex flex-col justify-between md:flex-row'>
                      <p className='text-h2-semibold sm:text-h1-semibold md:text-title3-bold text-sk-black'>
                        {portfolio.name}
                      </p>
                      <p className='text-body2-semibold sm:text-body1-semibold text-sk-sub'>
                        {portfolio.client}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* right */}
            <div className='w-1/2'>
              {projectRightList.map((portfolio, index) => (
                <div
                  key={index}
                  className='ml-20 cursor-pointer lg:ml-32 2xl:ml-64'
                  onClick={() => onClickPortfolioDetail(portfolio.id)}
                >
                  {/* 포트폴리오 이미지 */}
                  <div className='mb-28'>
                    <CardAnimation card={portfolio} />
                  </div>
                  {/* 포트폴리오 설명 */}
                  <div className='flex flex-col-reverse md:flex-col gap-4 mb-[60px] sm:mb-80'>
                    <p className='text-body2-medium text-sk-info'>{portfolio.description}</p>
                    <div className='flex flex-col justify-between md:flex-row'>
                      <p className='text-h2-semibold sm:text-h1-semibold md:text-title3-bold text-sk-black'>
                        {portfolio.name}
                      </p>
                      <p className='text-body2-semibold sm:text-body1-semibold text-sk-sub'>
                        {portfolio.client}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <ContactFloatingButton />
    </div>
  )
}
